export enum NotificationReason {
  assignment = 'assignment',
  comment = 'comment',
  mention = 'mention',
  itemMention = 'itemMention',
  itemSent = 'itemSent',
}
